import { useLocale } from '../../context';
import { useSiteContent } from '../../context/SiteContentContext';
import { CmsBreakText } from '../../utils/cmsBreakText';

function CheckIcon() {
  return (
    <svg
      className="svg-icon svg-icon--check-accented-secondary_static"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      data-testid="Block__icon"
    >
      <path d="M12 4.4a7.6 7.6 0 1 1 0 15.2 7.6 7.6 0 0 1 0-15.2Z" fill="#FCFCFD" fillOpacity="0.08" />
      <path d="M19.2 12a7.2 7.2 0 1 0-14.4 0 7.2 7.2 0 0 0 14.4 0Zm.8 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" fill="#FFF300" />
      <path d="M14.967 9.484a.466.466 0 0 1 .099.633l-3.6 4.95a.506.506 0 0 1-.324.183.487.487 0 0 1-.365-.127l-1.8-1.8a.477.477 0 0 1 0-.646.477.477 0 0 1 .646 0l1.42 1.434 3.291-4.528a.466.466 0 0 1 .633-.099Z" fill="#FFF300" />
    </svg>
  );
}

function pickText(text, locale, key, fallback) {
  if (!text) return fallback;
  const enKey = `${key}En`;
  if (locale === 'en') return text[enKey] || text[key] || fallback;
  return text[key] || text[enKey] || fallback;
}

export default function RegistrationLeftPanel() {
  const _locale = useLocale();
  const tr = _locale.t;
  const locale = _locale.locale;
  const { register } = useSiteContent();
  const offerImage = locale === 'ru' ? register?.offerRu : register?.offer;
  const bannerImage = register?.mainDesktop || offerImage;
  const text = register?.text;

  const highlight = pickText(text, locale, 'highlight', tr('auth.register.bannerHighlight'));
  const title = pickText(text, locale, 'title', tr('auth.register.bannerTitle'));
  const desc = pickText(text, locale, 'desc', tr('auth.register.bannerDesc'));
  const perk1 = pickText(text, locale, 'perk1', tr('auth.register.perkFast'));
  const perk2 = pickText(text, locale, 'perk2', tr('auth.register.perkSafe'));
  const perk3 = pickText(text, locale, 'perk3', tr('auth.register.perkBonus'));

  return (
    <div className="auth-banner">
      <div className="auth-banner__img">
        {bannerImage ? <img src={bannerImage} alt="" /> : null}
      </div>
      <div className="auth-banner__data">
        <div className="auth-banner__content">
          <div>
            <mark>
              <CmsBreakText text={highlight} />
            </mark>
            {' '}
            <CmsBreakText text={title} />
          </div>
          <div className="auth-banner__description">
            <CmsBreakText text={desc} />
          </div>
        </div>
        <div className="auth-banner__perks">
          <div className="auth-banner__perk">
            <div className="auth-banner__perk-icon"><CheckIcon /></div>
            <div className="auth-banner__perk-text"><CmsBreakText text={perk1} /></div>
          </div>
          <div className="auth-banner__perk">
            <div className="auth-banner__perk-icon"><CheckIcon /></div>
            <div className="auth-banner__perk-text"><CmsBreakText text={perk2} /></div>
          </div>
          <div className="auth-banner__perk">
            <div className="auth-banner__perk-icon"><CheckIcon /></div>
            <div className="auth-banner__perk-text"><CmsBreakText text={perk3} /></div>
          </div>
        </div>
      </div>
    </div>
  );
}
